import SelectFaculty from './SelectFaculty';

export default SelectFaculty;
